import React, { useState, Fragment, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  Avatar,
  Box,
  Badge,
  Menu,
  List,
  ListItem,
  Divider,
  Collapse,
  Typography,
  Grid,
} from '@material-ui/core';

import { ListItemButton,ListItemText, Switch,ListItemIcon,ListSubheader  } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MenuBulletIcon from '@material-ui/icons/FiberManualRecord';
import MenuOpenRoundedIcon from '@material-ui/icons/MenuOpenRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MenuIcon from '@material-ui/icons/Menu';
import AppsIcon from '@mui/icons-material/Apps';
import TuneIcon from '@mui/icons-material/Tune';
import KeyIcon from '@mui/icons-material/Key';
import SchoolIcon from '@mui/icons-material/School';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'; 
import InfoIcon from '@mui/icons-material/Info';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { getAccessPermission} from '../reducers/PermissionsReducer';
import store from '../config/configureStore';
import { getUserPermissions } from '../reducers/PermissionsReducer';
import { getServerTimeSettings } from 'reducers/TimeReducer';
import IconRms from '../assets/images/icon-RMS.svg';
import IconCad from '../assets/images/icon-CAD.svg';
import IconMobile from '../assets/images/icon-MOBILE.svg';
import IconAnalytics from '../assets/images/icon-ANALYTICS.png';
import IconArchive from '../assets/images/icon-ARC.png';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { getService } from 'reducers/service';
import Tooltip from '../components/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  setNavigationDrawerMobileState,
  setEventsDrawerMobileState,
  setUnitsDrawerMobileState,
} from '../reducers/UiReducer';
import { setMode } from '../reducers/ThemeReducer';
import { setUserAuthenticated,  authorizeExternalApp } from '../reducers/UserReducer';
import menuItems from '../config/configureMenu';
import settings from '../config/settings';
import { addPageDialog, showOptionsDialog } from '../reducers/DialogsReducer';
import AboutDialog from './AboutDialog';
import ReleaseNotesDialog from './ReleaseNotesDialog';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FilledInput,
  FormControl,
  InputLabel,
  TextField,
} from '@mui/material';
import { setConfigurationMenuEnabled } from 'reducers/ConfigReducer';
import { notify } from 'reducers/NotifierReducer';
import { setMenuState } from 'reducers/MenuReducer';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  leftMenu: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    '& button': {
      '& span': {
        marginRight: 8,
      },
    },
  },
  rightMenu: {
    alignSelf: 'center',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.topNav.bg,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: {
    height: settings.mainNavHeight,
    minHeight: settings.mainNavHeight,
    backgroundColor: theme.palette.bgElements,
  },
  btn: {
    width: '85px',
    height: '60px',
    border: '3px solid rgba(1, 83, 163, 0.5) !important',
  },
  btnLabel: {
    position: 'absolute',
    bottom: -3,
    left: 0,
    right: 0,
    textAlign: 'center',
  },
  activeNav: {
    '& > li': {
      fontWeight: 600,
    },
  },
  userName: {
    color: theme.colors.text1,
    marginLeft: 8,
  },
  arrowDn: {
    color: theme.colors.text1,
    marginLeft: 8,
  },
  fullWidthMenu: {
    zIndex: 2,
    position: 'absolute',
    top: settings.mainNavHeight,
    left: 0,
    right: 0,
    width: '100%',
    padding: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
  },
  searchMenu: {
    display: 'flex',
    '& h5': {
      paddingLeft: theme.spacing(2),
    },
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: 16,
      opacity: 0.25,
    },
    '& a': {
      color: theme.colors.text1,
    },
    '& a:hover': {
      color: theme.colors.text1,
    },
  },
  fwMenuWrap: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
  },
}));

const UserBadge = withStyles({
  badge: {
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
})(Badge);

const MainNav = props => {
  const classes = useStyles();  
  const { setMode, setUserAuthenticated, network, user, themeMode, menuState } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [displayAbout, setDisplayAbout] = useState(false);  
  const [userName, setUserName] = useState('');
  const [openPassPopup, setOpenPassPopup] = useState(false);
  const [rootPass, setRootPass] = useState('');
  const [displayReleaseNotes, setDisplayReleaseNotes] = useState(false);
  const [openAppSubmenu, setOpenAppSubmenu] = useState(false);
  const [openOptionSubmenu, setOpenOptionSubmenu] = useState(false);
  const [openCacheClearConfirmation, setOpenCacheClearConfirmation] = useState(false);

  const isPermissionLoaded = store.store.getState().permissions.loaded;
 
  const cadPermission =  isPermissionLoaded && getAccessPermission('modules', 'CAD','any');
  
  const analyticsPermission = getAccessPermission('modules', 'Analytics', 'any');
  const archivePermission = getAccessPermission('modules', 'Incident Archive', 'any');
  const mobilePermission =  isPermissionLoaded &&  getAccessPermission('modules', 'Mobile');
  
  const rmsPermission = isPermissionLoaded && (getAccessPermission('modules', 'RMS'));

  
  const handleAppClick = () => {
    setOpenAppSubmenu((prev) => !prev);
  };

  const handleOptionClick = () => {
    setOpenOptionSubmenu((prev) => !prev);
  };

  const redirectToApp = (url) => {
    if(url){
    authorizeExternalApp();
    const newWindow = window.open(url, '_blank');
    }else{
      dispatch(notify('Please set the proper link in configuration.', 'error'));
    }
  }

  const closeReleaseNotes = () => {
    setDisplayReleaseNotes(false);
  };

  const showReleaseNotes = () => {
    setDisplayReleaseNotes(true);
    handleClose();
  };

  const handleOpenSettings = () => {
    //authorizeExternalApp();
    //onClose();
  };

  const getHelpUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Help',
      CDRKey: 'HelpLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getTrainingUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Training',
      CDRKey: 'TrainingLink',
    });

     if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getRMSUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.RMS',
      CDRKey: 'RMSLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getCADUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.CAD',
      CDRKey: 'CADLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getMobileUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Mobile',
      CDRKey: 'MobileLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getAnalyticsUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Analytics',
      CDRKey: 'AnalyticsLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };
  
  const getArchiveUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Archive',
      CDRKey: 'ArchiveLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };
  

  const handleClearCache = () => {
    setOpenCacheClearConfirmation(true);      
  };

  const handleConfirmationClick = () => {
    const auth = localStorage.getItem('auth');
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('auth', auth);
    //history.push('/');
    window.location.reload();
  };

  const handleCloseDialog = () => {
    setOpenCacheClearConfirmation(false);
  };

  const toggleMode = () => {
    setMode();    
  };

  const reloadLookupCodesAndPermissions = () => {
    dispatch(getServerTimeSettings());
    dispatch(getUserPermissions());    
    handleClose();
    dispatch(notify('Code and Permissions reloaded successfully', 'success'));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (user.userData && user.userData.user) {
      let name = user.userData.user.Username;
      if (name !== userName) setUserName(name);
    }
    // eslint-disable-next-line
  }, [user]);

  const handleAboutClick = () => {
    setAnchorEl(null);
    setDisplayAbout(!displayAbout);
  };

  const StyledBadge = withStyles({
    badge: {
      backgroundColor: network.online === false ? 'var(--danger)' : 'var(--success)',
      color: network.online === false ? 'var(--danger)' : 'var(--success)',
    },
  })(UserBadge);

  const handleUserMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleColorMode = () => {
    setMode();
    handleClose();
  };

  const handleOptionsClick = () => {
    props.showOptionsDialog();
    handleClose();
  };
  const handleEnableConf = () => {
    setAnchorEl(null);
    setOpenPassPopup(true);
  };
  const renderUserMenu = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
        transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        onClose={handleClose}
        className="ml-2">
        <div className="dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0">
          <List className="text-left bg-transparent pt-0">
            <Box className='text-center'>
              <StyledBadge
                overlap="circle"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                variant="dot">
                <Avatar sizes="44" alt={userName} />
              </StyledBadge>
            </Box>
            <div>
              <div className="font-weight-bold text-center pt-2 line-height-1">{userName}</div>
            </div>
          <Divider className="w-100 mt-2" />            
            <ListItem>
              <ListItemIcon>
                {themeMode !== 'day' ? <WbSunnyIcon  />  : <DarkModeIcon  /> }
              </ListItemIcon>
              <ListItemText primary={themeMode !== 'day' ? "Light Mode" : "Dark Mode"} />
              <Switch checked={themeMode !== 'day'} onChange={toggleMode}/>                
            </ListItem>
            {(cadPermission || mobilePermission || analyticsPermission || rmsPermission || archivePermission) && (
              <>
                <ListItemButton button onClick={handleAppClick}>
                  <ListItemIcon>
                    <AppsIcon />
                  </ListItemIcon>
                  <ListItemText primary="My Applications" />
                  {openAppSubmenu ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>            
                <Collapse in={openAppSubmenu} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>                
                  {rmsPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getRMSUrl} button>
                      <ListItemIcon>
                        <img src={IconRms} alt="RMS icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="RMS" />
                    </ListItemButton>
                  )}                  
                  {cadPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getCADUrl} button>
                      <ListItemIcon>
                        <img src={IconCad} alt="CAD icon" style={{ width: 24, height: 24 }} />  
                      </ListItemIcon>
                      <ListItemText primary="CAD" />
                    </ListItemButton>  
                  )}
                  {mobilePermission && (              
                    <ListItemButton sx={{ pl: 5 }} onClick={getMobileUrl} button>
                      <ListItemIcon>
                        <img src={IconMobile} alt="MOBILE icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="Mobile" />
                    </ListItemButton>
                  )}
                  {analyticsPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getAnalyticsUrl} button>
                      <ListItemIcon>
                        <img src={IconAnalytics} alt="Analytics icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="Analytics" />
                    </ListItemButton>
                  )}
                  {archivePermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getArchiveUrl} button>
                      <ListItemIcon>
                        <img src={IconArchive} alt="Archive icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="Archive Browser" />
                    </ListItemButton>
                  )}
                  </List>
                </Collapse>
              </>
            )}
            <ListItemButton button onClick={handleOptionClick}>
              <ListItemIcon>
                <TuneIcon />
              </ListItemIcon>
              <ListItemText primary="Options" />
              {openOptionSubmenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>            
            <Collapse in={openOptionSubmenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 5 }} onClick={() => handleOptionsClick()} button>
                <ListItemIcon>
                  <KeyIcon />
                </ListItemIcon>
                <ListItemText primary="Change Password" />
              </ListItemButton>      
              <ListItemButton sx={{ pl: 5 }} onClick={reloadLookupCodesAndPermissions} button>
                <ListItemIcon>
                  <RestartAltIcon />
                </ListItemIcon>
                <ListItemText primary="Reload Codes & Permissions" />
              </ListItemButton>         
              <ListItemButton sx={{ pl: 5 }} onClick={handleClearCache} button>
                <ListItemIcon>
                  <DeleteSweepIcon />
                </ListItemIcon>
                <ListItemText primary="Clear Cache" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 5 }} onClick={() => handleEnableConf()} button>
                <ListItemIcon>
                  <ManageAccountsIcon />
                </ListItemIcon>
                <ListItemText primary="Enable Configuration Menu" />
              </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton onClick={getTrainingUrl} button>
              <ListItemIcon>
                <SchoolIcon />
              </ListItemIcon>
              <ListItemText primary="Training Academy" />
            </ListItemButton>       
            <ListItemButton onClick={getHelpUrl} button>
              <ListItemIcon>
                <HeadsetMicIcon />
              </ListItemIcon>
              <ListItemText primary="Contact Support" />
            </ListItemButton>          

           <ListItemButton button onClick={showReleaseNotes}>
              <ListItemIcon>
                <NewReleasesIcon />
              </ListItemIcon>
              <ListItemText primary="Release Notes" />
            </ListItemButton> 

           <ListItemButton button onClick={() => handleAboutClick()}>
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary="About" />
            </ListItemButton>
            <Divider className="w-100" />
            <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
              <Button
                onClick={() => setUserAuthenticated(false)}
                variant="outlined"
                size="medium"
                color="default">
                <span className="btn-wrapper--icon">
                  <FontAwesomeIcon icon={['fas', 'sign-out-alt']} />
                </span>
                <span className="btn-wrapper--label">Logout</span>
              </Button>
            </ListItem>
          </List>          
          
          <Dialog  
            open={openCacheClearConfirmation} 
            onClose={handleCloseDialog}
            maxWidth='md'>
            <DialogTitle style={{ background: '#2871cc', color: 'white' }}>
              {<Typography variant="h5">Confirmation!</Typography>}
            </DialogTitle>
            <DialogContent style={{ display: 'flex', alignItems: 'center' }}>
              <Grid container>          
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom component="div" style={{ marginTop : 10,}}>
                    Clearing the cache will log you out of the system. You will lose all unsaved progress. . Do you wish to proceed?
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <div className="mb-1">
                  <Button
                    onClick={handleConfirmationClick}
                    style={{ background: '#2871cc', color: '#fff', width: '80px', marginRight: '5px' }}>
                    Yes
                  </Button>                
                <Button
                  onClick={handleCloseDialog}
                  style={{ background: '#2871cc', color: '#fff', width: '80px' }}>
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>          
        </div>
      </Menu>
    );
  };

  const renderDesktopMenu = () => {
    return (
      <div className={classes.wrapper}>
        <div className={classes.leftMenu}>
          <div>
            {menuItems.map((btn, idx) => (
              <Tooltip title={btn.tooltip} key={idx}>
                <NavLink to={btn.link} activeClassName={classes.activeNav}>
                  <Button>{btn.label}</Button>
                </NavLink>
              </Tooltip>
            ))}
          </div>
        </div>

        <div className={classes.rightMenu}>
          <Button
            color="inherit"
            onClick={handleUserMenuClick}
            className="text-capitalize px-3 text-left btn-inverse d-flex align-items-center">
            <Box className={classes.avatar}>
              <Avatar sizes="30" alt={userName} />
            </Box>
            <span className={classes.userName}>{userName}</span>
            <span className={classes.arrowDn}>
              <FontAwesomeIcon icon={['fas', 'angle-down']} className="opacity-5" />
            </span>
          </Button>
        </div>
      </div>
    );
  };
  const renderPasswordPopup = () => {
    const handlePassPopupClose = () => {
      setOpenPassPopup(false);
    };
    const handlePassCheck = async () => {
      const service = getService('cdr');
      const data = await service.get({ Path: 'PTS_ADMIN_PASSWORD', CDRKey: 'PASSWORD' });
      if (data && data.length > 0 && data[0].ValueString === rootPass) {
        setOpenPassPopup(false);
        dispatch(setConfigurationMenuEnabled(true));
        // dispatch(notify('Configuration menu enabled', 'success'));

        dispatch(setMenuState({ ...menuState, Configurations: true }));
      } else {
        dispatch(notify('Wrong Password', 'error'));
      }
    };
    return (
      <Dialog open={openPassPopup} onClose={handlePassPopupClose} maxWidth="sm" fullWidth>
        <DialogTitle>Authorization</DialogTitle>
        <DialogContent>
          <DialogContentText>Please enter the PTS password</DialogContentText>
          <div className="pt-3">
            <TextField
              autoFocus
              size="small"
              required
              variant="outlined"
              label="Password"
              fullWidth
              placeholder="Enter your password"
              type={'password'}
              value={rootPass}
              onChange={e => setRootPass(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button  size="medium" color="primary" variant="contained"  onClick={handlePassCheck}>Submit</Button>
          <Button  size="medium" color="primary"  variant="outlined"  onClick={handlePassPopupClose}> Close</Button>
        </DialogActions>
      </Dialog>
    );
  };
  return (
    <Fragment>
      <AppBar color="primary" position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {renderDesktopMenu()}
          {renderUserMenu()}
          {renderPasswordPopup()}
        </Toolbar>
      </AppBar>
      {displayAbout && <AboutDialog close={handleAboutClick} />}
      {displayReleaseNotes && <ReleaseNotesDialog close={closeReleaseNotes} />}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  network: state.offline,
  themeMode: state.theme.mode,
  user: state.user,
  menuState: state.menu,
});

export default connect(mapStateToProps, {
  setNavigationDrawerMobileState,
  setEventsDrawerMobileState,
  setUnitsDrawerMobileState,
  setMode,
  setUserAuthenticated,
  addPageDialog,
  showOptionsDialog,
})(MainNav);